import ChangePasswordForm from './ChangePasswordForm';

const initialValues: ChangePasswordForm = {
    currentPassword: '',
    newPassword: '',
    newPasswordAgain: '',
};

export default initialValues;
